import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getVisitorId() {
  let id = localStorage.getItem("rc_visitor_id");
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "v-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    localStorage.setItem("rc_visitor_id", id);
  }
  return id;
}

export async function trackEvent(type, data = {}) {
  try {
    await axios.post(`${API}/track`, {
      visitor_id: getVisitorId(),
      type,
      path: window.location.pathname,
      ...data,
    });
  } catch (e) {
    /* tracking is best-effort */
  }
}
